import z from 'zod';

export const MEDICATION_IMPORT_MAX_FILE_SIZE = 50 * 1024 * 1024;

export const medicationImportFileSchema = z
  .file({ error: 'Selecione um arquivo .zip' })
  .refine(file => file.name.toLowerCase().endsWith('.zip'), {
    error: 'Apenas arquivos .zip são aceitos',
  })
  .refine(file => file.size > 0, { error: 'O arquivo está vazio' })
  .refine(file => file.size <= MEDICATION_IMPORT_MAX_FILE_SIZE, {
    error: 'O arquivo deve ter no máximo 50 MB',
  });
